"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupMenu = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const components_1 = require("../components");
const PopupMenuElementsMapper_1 = require("../config/PopupMenuElementsMapper");
const store_1 = require("../store");
const Menu_context_1 = require("../store/Menu.context");
const DrawerMenu_1 = require("./DrawerMenu");
const PopupMenu_styles_1 = require("./PopupMenu.styles");
exports.PopupMenu = (0, react_1.memo)(function PopupMenu({ options, onUpdate, onVisibilityChange, }) {
    var _a;
    const optionMenu = (0, Menu_context_1.useMenu)(); //TODO: Change name
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const menuDispatch = (0, store_1.useMenuDispatch)();
    const [overflowOptions, setOverflowOptions] = (0, react_1.useState)([]);
    const handleOpenSections = (0, react_1.useCallback)(({ open, id }) => {
        menuDispatch({
            type: 'SET_SECTION',
            payload: {
                isVisible: open,
                name: id,
            },
        });
    }, [menuDispatch]);
    const activeSection = (() => {
        const option = options.find((option) => option.id === optionMenu.SECTION.name);
        return option;
    })();
    const ref = (0, react_1.useRef)(null);
    const popupMenuWrapperRef = (0, react_1.useRef)(null);
    const gapSize = 8;
    const debouncedHandleResize = (0, react_1.useCallback)(ui_common_components_1.utils.debounce(() => {
        var _a;
        if (!popupMenuWrapperRef.current)
            return;
        const popupMenuElement = popupMenuWrapperRef === null || popupMenuWrapperRef === void 0 ? void 0 : popupMenuWrapperRef.current;
        const clientWidth = popupMenuElement.getBoundingClientRect().width;
        if (!popupMenuElement) {
            return;
        }
        const elements = popupMenuElement.querySelectorAll('.popupmenu-item');
        let accumulatedWidth = gapSize;
        let maxVisibleItems = 0;
        //TODO: Sometimes it flicks here when it is resizing, should be fixed
        for (let i = 0; i < options.length; i++) {
            const itemWidth = ((_a = elements[i]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) + gapSize;
            accumulatedWidth += itemWidth;
            if (accumulatedWidth > clientWidth) {
                if (maxVisibleItems > 0) {
                    --maxVisibleItems;
                }
                break;
            }
            maxVisibleItems++;
        }
        const overflowArray = options.slice(maxVisibleItems).reverse();
        setOverflowOptions(overflowArray);
    }, 250), [options, popupMenuWrapperRef]);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', debouncedHandleResize);
        debouncedHandleResize();
        return () => {
            window.removeEventListener('resize', debouncedHandleResize);
        };
    }, [debouncedHandleResize, options, popupMenuWrapperRef]);
    return ((0, jsx_runtime_1.jsxs)(PopupMenu_styles_1.StyledPopupMenuContainer, { ref: popupMenuWrapperRef, children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Panel, { children: (0, jsx_runtime_1.jsxs)(ui_common_components_1.Panel.Content, { children: [options
                            .filter((option) => {
                            return !overflowOptions.some((testOption) => testOption.id === option.id);
                        })
                            .map((_a) => {
                            var { data } = _a, option = tslib_1.__rest(_a, ["data"]);
                            return ((0, jsx_runtime_1.jsx)("div", { className: "popupmenu-item", children: (0, PopupMenuElementsMapper_1.PopupMenuMapper)(Object.assign(Object.assign({}, option), { data, title: t(data.titleKey || option.titleKey), handleOpenSections, onUpdate: (data) => (option.onUpdate || onUpdate)({
                                        action: option.action,
                                        data,
                                    }) })) }, option.id));
                        }), optionMenu.selectedElements.length > 0 &&
                            overflowOptions.length > 0 && ((0, jsx_runtime_1.jsx)(ui_common_components_1.DropdownNext, { options: [
                                {
                                    type: 'custom',
                                    value: 'more-options',
                                    children: ((0, jsx_runtime_1.jsx)(PopupMenu_styles_1.StyledContainer, { children: overflowOptions.map((_a) => {
                                            var { data } = _a, element = tslib_1.__rest(_a, ["data"]);
                                            return ((0, jsx_runtime_1.jsx)("div", { className: "popupmenu-item", children: (0, PopupMenuElementsMapper_1.PopupMenuMapper)(Object.assign(Object.assign({}, element), { data, title: t(data.titleKey || element.titleKey), handleOpenSections, onUpdate: (data) => (element.onUpdate || onUpdate)({
                                                        action: element.action,
                                                        data,
                                                    }) })) }, `poupmenu-option-${element.id}`));
                                        }) })),
                                },
                            ], trigger: "click", children: (0, jsx_runtime_1.jsx)(PopupMenu_styles_1.StyledButton, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "ghost", icon: { name: 'more-options---20', size: 'Small' }, onClick: (event) => event === null || event === void 0 ? void 0 : event.preventDefault() }) }) }))] }) }), optionMenu.SECTION.isVisible && ((0, jsx_runtime_1.jsxs)(DrawerMenu_1.DrawerContainer, { id: ((_a = optionMenu === null || optionMenu === void 0 ? void 0 : optionMenu.SECTION) === null || _a === void 0 ? void 0 : _a.name)
                    ? optionMenu.SECTION.name
                    : (activeSection === null || activeSection === void 0 ? void 0 : activeSection.id) || '', ref: ref, children: [activeSection && activeSection.component === 'section' && ((0, jsx_runtime_1.jsx)(components_1.Section, { variant: activeSection.variant, items: activeSection.items, id: activeSection.id, title: t(activeSection.titleKey), onUpdate: (data) => (activeSection.onUpdate || onUpdate)({
                            action: activeSection.action,
                            data,
                        }), data: activeSection.data, onVisibilityChange: onVisibilityChange })), activeSection && activeSection.component === 'tabs' && ((0, jsx_runtime_1.jsx)(components_1.Tabs, { variant: activeSection.variant, title: t(activeSection.titleKey), tabs: activeSection.tabs, data: activeSection.data, render: activeSection.render, onUpdate: (data) => (activeSection.onUpdate || onUpdate)({
                            action: activeSection.action,
                            data,
                        }) }))] }))] }));
});
//# sourceMappingURL=PopupMenu.js.map